// @mui
import { Container, Grid } from '@mui/material';

import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores/store';

//Localization
import useLocales from 'src/hooks/useLocales';
import Page from 'src/components/Page';
import useSettings from 'src/hooks/useSettings';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from 'src/routes/paths';
import IncomeDetailTableRow from './IncomeDetailTableRow';
import { useEffect, useState } from 'react';
import Loader from 'src/components/loader/Loader';
// ----------------------------------------------------------------------

export default observer(function IncomeDetailHeader() {
  const { translate } = useLocales();
  const [isLoading, setIsLoading] = useState(true); // Track loading state
  const {
    IncomeStore: { selectedIncomeDetail, clearSelectedIncome, ID, loadIncomeDetail },
  } = useStore();

  useEffect(() => {
    if (ID) {
      setIsLoading(true);
      loadIncomeDetail(ID).finally(() => setIsLoading(false)); // Ensure loading ends
    }
  }, [loadIncomeDetail, ID]);

  const { themeStretch } = useSettings();
  return (
    <Page title={translate('Income.IncomeDetails')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('Income.IncomeDetails')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            { name: `${translate('Income.IncomeList')}`, href: PATH_DASHBOARD.Income.list },
            { name: `${translate('Income.IncomeDetails')}` },
          ]}
        />

        {isLoading ? ( // Show loading state
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>

            <Loader /> {/* Replace with Loader */}
          </Grid>
        ) : selectedIncomeDetail ? ( // Render details if available
          <Grid container>
            <Grid container>
              <IncomeDetailTableRow row={selectedIncomeDetail!} />
            </Grid>
          </Grid>
        ) : (
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <p>{translate('ElectricBox.NoData')}</p>
          </Grid>
        )}

      </Container>
    </Page>
  );
});
